import styled from 'styled-components';
import Banner01 from '../../assets/index-banner-01.png';
import Banner02 from '../../assets/index-banner-02.png';
import BannerMobile01 from '../../assets/index-banner-mobile-01.png';
import BannerMobile02 from '../../assets/index-banner-mobile-02.png';
import { Carousel as AntCarousel } from 'antd';

const StyledCarousel = styled(AntCarousel)`
  font-family: 'Nunito', sans-serif;
  font-weight: 200 !important;

  .slick-dots-bottom {
    bottom: 40px;
  }

  .slick-dots li {
    width: 400px;
    height: 5px;
    padding: 0;
    margin-right: 10px;

    button {
      width: 400px;
      height: 5px;
      padding: 0;
      background: #e4d3c8 !important;
    }

    &.slick-active {
      width: 400px;
      height: 5px;

      button {
        width: 400px;
        height: 6px;
        background: #f87b15 !important;
      }
    }

    &::after {
      height: 4px !important;
      background: #f87b15 !important;
    }
  }

  @media (max-width: 768px) {
    .slick-dots li {
      width: 70px;

      button {
        width: 70px;
      }

      &.slick-active {
        width: 70px;

        button {
          width: 70px;
        }
      }
    }
  }
`;

const CarouselContainer = styled.div`
  width: 100%;
`;

const CarouselItem = styled.div<{ $isSecondSlide?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: ${props => props.$isSecondSlide ? 'flex-start' : 'center'};
  justify-content: ${props => props.$isSecondSlide ? 'flex-start' : 'center'};
  height: 612px;
  background-size: cover;
  background-position: center;

  @media (min-width: 768px) {
    flex-direction: row;
    height: 700px;
  }
`;

const BannerImage = styled.img<{ $isMobile?: boolean }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media (max-width: 768px) {
    display: ${props => props.$isMobile ? 'block' : 'none'} !important;
  }

  @media (min-width: 769px) {
    display: ${props => props.$isMobile ? 'none' : 'block'} !important;
  }
`;

const ContentContainer = styled.div<{ $isSecondSlide?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 0.375rem;
  margin: 1rem;
  color: ${props => props.$isSecondSlide ? '#ffffff' : 'inherit'};
  text-align: center;
  font-weight: 200;

  @media (min-width: 768px) {
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    margin: 2rem;
  }
`;

const Title = styled.div<{ $isSecondSlide?: boolean }>`
  font-size: 2.8rem;
  font-weight: 700 !important;
  margin-top: 0.625rem;
  margin-bottom: 0.9375rem;
  line-height: 1.1;
  color: ${props => props.$isSecondSlide ? '#fff !important' : '#000'};

  p:first-child {
    margin-bottom: 0.2em;
  }

  @media (min-width: 768px) {
    font-size: 3.5rem;
    margin-top: 8.75rem;
    margin-bottom: 2.1875rem;
    line-height: normal;
  }
`;

const SubtitleContainer = styled.div`
  max-width: max-content;
`;

const Subtitle = styled.div<{ $isMobile?: boolean; $isSecondSlide?: boolean }>`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  line-height: 1;
  display: ${props => props.$isMobile ? 'block' : 'none'};
  font-weight: 400 !important;
  color: ${props => props.$isSecondSlide ? '#fff !important' : '#000 !important'};

  p {
    color: ${props => props.$isSecondSlide ? '#fff !important' : '#000 !important'};
  }

  @media (min-width: 768px) {
    font-size: 2rem;
    display: ${props => props.$isMobile ? 'none' : 'block'};
  }
`;

const Button = styled.a<{ $isSecondSlide?: boolean }>`
  background-color: ${props => props.$isSecondSlide ? '#ffffff' : '#f97316'};
  color: ${props => props.$isSecondSlide ? '#000000' : '#000000'};
  font-weight: 700;
  padding: 0.5rem 1.5rem;
  border-radius: 0.625rem;
  font-size: 1.25rem;
  margin-top: 0.5rem;
  text-align: center;

  &:hover {
    color: #000000;
    background-color: #ffffff;
  }

  @media (min-width: 768px) {
    padding: 1rem 2rem;
    margin-top: 1rem;
  }
`;

export default () => {
  return (
    <CarouselContainer>
      <StyledCarousel arrows autoplay autoplaySpeed={5000}>
        <CarouselItem>
          <BannerImage src={BannerMobile01} alt="Banner Mobile 01" $isMobile />
          <BannerImage src={Banner01} alt="Banner 01" />
          <ContentContainer>
            <Title>
              <p style={{ color: '#f87b15' }}>Just Released! </p>
              <p style={{ color: '#000000' }}>Indoor Pan - Tilt Camera</p>
            </Title>
            <SubtitleContainer>
              <Subtitle>
                <p>Giving you 360 - degree coverage, AI - powered </p>
                <p>tracking, and 2.4K HD video, so you can capture every </p>
                <p>memory, even when you&apos;re away.</p>
              </Subtitle>
              <Subtitle $isMobile>
                <p>Giving you 360 - degree coverage </p>
                <p>AI - powered</p>
                <p>tracking, and 2.4K HD video</p>
              </Subtitle>
            </SubtitleContainer>
            <Button href="/indoor-pan-tilt-camera">
              Explore Features
            </Button>
          </ContentContainer>
        </CarouselItem>
        <CarouselItem $isSecondSlide>
          <BannerImage src={BannerMobile02} alt="Banner Mobile 02" $isMobile />
          <BannerImage src={Banner02} alt="Banner 02" />
          <ContentContainer $isSecondSlide>
            <Title $isSecondSlide style={{ color: '#fff' }}>
              <p style={{ color: '#fff' }}>Sensforge: </p>
              <p style={{ color: '#fff' }}>Where Security </p>
              <p style={{ color: '#fff' }}>Meets Fun</p>
            </Title>
            <Button href="/indoor-pan-tilt-camera" $isSecondSlide>
              Learn More
            </Button>
          </ContentContainer>
        </CarouselItem>
      </StyledCarousel>
    </CarouselContainer>
  );
};